module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-bg-1-4850f76a102bd7c5334a5aac303a86a2.png";